import { Icon } from '@elotech/components';
import { useContext } from 'react';

import { ProgressContext } from './ProgressContainer';

export const ProgressButton = () => {
  const { count, setModalVisible, progresses, modalVisible } =
    useContext(ProgressContext);
  const isRunning = progresses
    ? Object.values(progresses).some(p => p.running)
    : false;
  if (!count) {
    return null;
  }
  return (
    <li
      title="Progresso de tarefas"
      onClick={() => !modalVisible && setModalVisible?.(true)}
    >
      <Icon icon="cogs" className="cogs" />
      <small className="hidden-xs">Progresso</small>
      <span
        className={`bubble-notification warning ${isRunning ? 'loading' : ''}`}
      >
        {count}
      </span>
    </li>
  );
};
